import { DataTable } from 'primereact/datatable';
import React, { useState } from 'react';
import { Column } from 'primereact/column';
import { UnfinishedLectureDb } from '../../../../api/types/home-data/home-data';
import dateUtils from '../../../../utils/date-format';
import { Button } from 'primereact/button';
import { ManualFinishLectureDialog } from './manual-finish-lecture-dialog';

interface UnfinishedLecturesProps {
  unfinishedLectures: UnfinishedLectureDb[];
  onUpdate: () => any;
}

const UnfinishedLectures: React.FC<UnfinishedLecturesProps> = ({
  unfinishedLectures,
  onUpdate,
}) => {
  const [selectedLecture, setSelectedLecture] =
    useState<UnfinishedLectureDb | null>(null);
  const [showFinishDialog, setShowFinishDialog] = useState(false);

  const handleFinishClick = (lecture: UnfinishedLectureDb) => {
    setSelectedLecture(lecture);
    setShowFinishDialog(true);
  };

  const handleDialogClose = () => {
    setShowFinishDialog(false);
    setSelectedLecture(null);
  };

  const handleSuccess = () => {
    handleDialogClose();
    onUpdate();
  };

  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        padding: '20px',
        height: '100%',
        borderRadius: '12px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: '5px',
        }}
      >
        <div
          style={{ paddingBottom: '10px', color: '#185FD3', fontSize: '18px' }}
        >
          מפגשים שטרם נסגרו ({unfinishedLectures.length})
        </div>
      </div>
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        value={unfinishedLectures}
        scrollHeight="200px"
        scrollable
        dataKey="sessionId"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
        rowHover
      >
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="programName"
          header="תוכנית לימודים"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: UnfinishedLectureDb) => (
            <div>{rowData.programName}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="courseName"
          header="שם קורס"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: UnfinishedLectureDb) => (
            <div>{rowData.courseName}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="lectureName"
          header="שם מפגש"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: UnfinishedLectureDb) => (
            <div>{rowData.lectureName || 'ללא שם'}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="sessionStartAt"
          header="התחיל ב"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: UnfinishedLectureDb) => (
            <div>
              {dateUtils.displayFormatDate(rowData.sessionStartAt)} -{' '}
              {dateUtils.formatTimeFromDate(rowData.sessionStartAt)}
            </div>
          )}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="lecturer"
          header="מרצה"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: UnfinishedLectureDb) => (
            <div>
              {rowData.lecturer.firstName} {rowData.lecturer.lastName}
            </div>
          )}
        />
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          header="פעולות"
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(rowData: UnfinishedLectureDb) => (
            <Button
              label="סיים ידנית"
              icon="pi pi-check"
              severity="success"
              size="small"
              outlined
              onClick={() => handleFinishClick(rowData)}
            />
          )}
        />
      </DataTable>

      {selectedLecture && (
        <ManualFinishLectureDialog
          visible={showFinishDialog}
          lecture={selectedLecture}
          onHide={handleDialogClose}
          onSuccess={handleSuccess}
        />
      )}
    </div>
  );
};

export default UnfinishedLectures;
